import React from 'react';
export function DiamondIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-21" data-mp="2ix64m090j7vr">
      <path d="M6 3h12l4 6-10 12L2 9l4-6Z M2 9h20 M9 3 7.5 9 12 21 16.5 9 15 3" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" strokeLinecap="round" data-id="element-22" data-mp="2xlsh7u799lja" />
    </svg>;
}